import { useEffect, useMemo, useState } from 'react';
import { SocketNamespace } from '@trinity/chat';
import type { Socket } from 'socket.io-client';
import { createLogger } from '../utils';
import { useGetSocket } from './useGetSocket';
import { useSetupDefaultSocketListeners } from './useSetupDefaultListeners';

export const useMessageGenerationSocket = (sessionId?: number): Socket | undefined => {
  const [socket, setSocket] = useState<Socket | undefined>();
  const getSocket = useGetSocket(SocketNamespace.MessageGeneration);

  const logger = useMemo(() => createLogger({ namespace: SocketNamespace.MessageGeneration }), []);

  useEffect(() => {
    if (sessionId) {
      logger.log(`Setting up socket for message-gen session: ${sessionId}`);
      const newSocket = getSocket();
      setSocket(newSocket);

      logger.log(`Subscribing to message-gen session: ${sessionId}`);
      newSocket.emit('subscribe', sessionId);

      return () => {
        logger.log(`Cleaning up socket for message-gen session: ${sessionId}`);
        newSocket.emit('unsubscribe', sessionId);
        newSocket.disconnect();
      };
    }
  }, [getSocket, logger, sessionId]);

  useSetupDefaultSocketListeners(socket, SocketNamespace.MessageGeneration);

  return socket;
};
